import React from "react";

// import Badge from "../../Components/Utils/Badge.js";

export default function StaffDashboard() {
  return <>Dashboard</>;
}
